module.exports = __webpack_public_path__ + "static/media/irish.0170a99c.jpg";